<app-z-dialog
  [title]="('COMMON.EDIT_EMAIL' | translate) + ' - ' + name"
  [contentTemplate]="contentTemplate"
  [actionButtonsTemplate]="buttonsTemplate"
>
</app-z-dialog>

<ng-template #contentTemplate>
  <z-input
    [label]="'COMMON.EMAIL' | translate"
    [formControlRef]="email"
    [email]="true"
    [required]="true"
  ></z-input>
</ng-template>

<ng-template #buttonsTemplate>
  <z-button
    [label]="'COMMON.SAVE' | translate"
    icon="check"
    color="primary"
    [mat-dialog-close]="true"
    (clicked)="send()"
    cdkFocusInitial
  ></z-button>
</ng-template>

